import React, { useState } from "react"
import toast from "react-hot-toast"
import { Link, useHistory } from "react-router-dom"
import { Col, Row } from "reactstrap"

import {
   DeletePackage,
   GetPackagesListing,
   UpdatePackage,
} from "../../../api/api.service"
import { AutoComplete } from "../../../components/AutoComplete"
import { Button } from "../../../components/Button"
import { DataTable } from "../../../components/DataTable"
import { Pagination } from "../../../components/Pagination"
import { SearchBox } from "../../../components/SearchBox"
import { ConfiguratorPackagesStatus } from "../../../constants"
import { APP_ROUTES, getRoute } from "../../../helpers/routeHelpers"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import {
   convertToSelectOptions,
   replaceSlashes,
} from "../../../utils/commonUtils"
import ActiveInactiveSwitch from "../../Configurator/CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import DeleteModal from "../../Configurator/CommonUI/Modal/DeleteModal"
import { TOGGLE_STATUS } from "../../Configurator/Packages/FormConfig"

import editIcon from "../../../assets/images/icons/edit-icon.svg"
import eyeIcon from "../../../assets/images/icons/eye-icon.svg"
import DeleteIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"
import settingsIcon from "../../../assets/images/icons/settings-icon.svg"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import ManageGlobalPackages from "./ManageGlobalPackages"
import useRenderUsedIn from "hooks/useRenderUsedIn"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"

const COLUMNS = {
   ITEM_NAME: "Package name",
   PACKAGE_MARKETING_PRICE: "Marketing Price",
   PACKAGE_PRODUCTION_COST: "Production Cost",
   STATUS: "Status",
   ACTIONS: "Actions",
   CUSTOMIZE: "Customize",
   ITEM_COUNT: "Item Count",
   POPULAR_PACKAGE: "Popular Package",
   USED_IN: "Used In",
}
const DATA_KEY = "data"
const TOTAL_KEY = "total"
const GlobalPackages = ({}) => {
   const history = useHistory()
   const [statusFilters, setStatusFilters] = useState(null)
   const [delId, setDelId] = useState(null)
   const [selection, setSelection] = useState({})
   const [openDelModal, setOpenDelModal] = useState(false)

   const {
      data,
      isFetching,
      page,
      searchText,
      pageSize,
      total,
      handleSearchChange,
      request,
      handlePageClick,
      onChangePageSize,
      setTableDataChangeLoading,
      tableDataChangeLoading,
      setData,
   } = useLocalPaginatedRequest({
      requestFn: GetPackagesListing,
      params: {
         ...(statusFilters?.value && { status: statusFilters?.value }),
      },
      deps: [statusFilters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const renderUsedIn = useRenderUsedIn({
      listKey: "configuratorTrailerPackages",
   })

   const [eventsType, setEventsType] = useState({
      isManage: null,
      isUpdate: null,
      isDetails: null,
   })

   const handleInitManage = obj => {
      setEventsType(prev => ({ ...prev, isManage: true }))
      setSelection(obj)
   }

   const handleInitViewDetails = obj => {
      setSelection(obj)
      setEventsType(prev => ({ ...prev, isDetails: true, isManage: true }))
   }

   const handleSelectStatusOption = option => {
      setStatusFilters(option)
   }

   const handleStatusChange = async (currStatus, id) => {
      let status =
         currStatus === ConfiguratorPackagesStatus.Active
            ? ConfiguratorPackagesStatus.Inactive
            : ConfiguratorPackagesStatus.Active
      let dataClone = [...data]
      dataClone.map(el => {
         if (el?.id == id) el.status = status
      })
      setData(dataClone)
      let payload = {
         status: status,
      }
      try {
         setTableDataChangeLoading(true)
         let res = await UpdatePackage(id, payload)
         toast.success("Package status has been updated !")
      } catch (err) {
         let dataClone = [...data]
         dataClone.map(el => {
            if (el?.id == id) el.status = currStatus
         })
         setData(dataClone)
      } finally {
         setTableDataChangeLoading(false)
      }
   }

   const handleNavigateToPackagesItems = obj => {
      setSelection(obj)

      return history.push(
         getRoute(
            APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_PACKAGES_ITEMS,
            {
               packageId: obj.id,
               packageName: replaceSlashes(obj.packageName),
            }
         )
      )
   }

   const handleInitDelete = obj => {
      setDelId(obj.id)
      setOpenDelModal(prev => !prev)
   }

   return (
      <>
         <Link to={APP_ROUTES.CONFIGURATOR_TRAILERS}>
            <div className="d-flex align-items-center gap-2  configurator-top-link">
               <span className="configurator-global-arrow">&lt;</span>{" "}
               Configurator Settings
            </div>
         </Link>

         <div className="mb-3 trailer-container">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <h3 className="configurator-global-heading">Packages</h3>
               <div />

               <Button
                  className={`header-button headerButtonResponsive`}
                  title="Add Package"
                  onClick={() => handleInitManage({})}
               />
            </div>
         </div>

         <div className="mb-3">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
               <div className="status-search-con wh-im-dpgi-status  me-2 ">
                  <AutoComplete
                     value={statusFilters}
                     isClearable
                     onChange={val => handleSelectStatusOption(val)}
                     isSearchable={false}
                     placeholder="Select status"
                     customStyles={autoCompleteStyles.STYLE_SIX}
                     classNamePrefix="status-header-search-admin"
                     options={convertToSelectOptions(
                        ConfiguratorPackagesStatus
                     )}
                  />
               </div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class"
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>

         <Row>
            <Col md={12}>
               <DataTable
                  data={data}
                  tableClasses="package-table"
                  loading={isFetching}
                  config={[
                     {
                        title: COLUMNS.ITEM_NAME,
                        className: "",
                        render: data => {
                           return (
                              <TruncatedTextWithTooltip
                                 text={data.packageName}
                              />
                           )
                        },
                     },

                     {
                        title: COLUMNS.PACKAGE_PRODUCTION_COST,
                        className: "",
                        render: data =>
                           `$${Number(data?.productionPrice).toFixed(2)}` ||
                           "-",
                     },

                     {
                        title: COLUMNS.PACKAGE_MARKETING_PRICE,
                        className: "",
                        render: data =>
                           `$${Number(data?.price).toFixed(2)}` || "-",
                     },
                     {
                        title: COLUMNS.CUSTOMIZE,
                        className: "",
                        render: data => (data.isCustomizable ? "Yes" : "No"),
                     },
                     {
                        title: COLUMNS.ITEM_COUNT,
                        className: "",
                        render: data => data.items?.length,
                     },
                     {
                        title: COLUMNS.POPULAR_PACKAGE,
                        className: "",
                        render: data =>
                           data?.isPopular
                              ? TOGGLE_STATUS.Yes
                              : TOGGLE_STATUS.No,
                     },
                     {
                        title: COLUMNS.USED_IN,
                        className: "",
                        render: renderUsedIn,
                     },
                     {
                        title: COLUMNS.STATUS,
                        className: "",
                        render: data => (
                           <ActiveInactiveSwitch
                              isDisable={tableDataChangeLoading}
                              id={data.id}
                              name={`${data.id}`}
                              onChange={e =>
                                 handleStatusChange(data?.status, data?.id)
                              }
                              isChecked={
                                 data?.status ==
                                 ConfiguratorPackagesStatus.Active
                              }
                           />
                        ),
                     },

                     {
                        title: COLUMNS.ACTIONS,

                        render: data => (
                           <div className="d-flex gap-2 pointer">
                              <img
                                 src={eyeIcon}
                                 onClick={() => handleInitViewDetails(data)}
                              />

                              <img
                                 src={editIcon}
                                 onClick={() => handleInitManage(data)}
                              />
                              <img
                                 src={settingsIcon}
                                 onClick={() =>
                                    handleNavigateToPackagesItems(data)
                                 }
                              />
                              <img
                                 src={DeleteIcon}
                                 onClick={() => handleInitDelete(data)}
                              />
                           </div>
                        ),
                     },
                  ]}
               />
            </Col>
            <Pagination
               currentPage={page}
               totalData={total}
               onPageClick={handlePageClick}
               rowLimit={pageSize}
               onChangePageSize={onChangePageSize}
            />
         </Row>

         <ManageGlobalPackages
            isDetailView={eventsType.isDetails}
            isOpen={eventsType.isManage}
            id={selection?.id}
            onSuccess={request}
            onToggleModal={() => {
               setSelection({})
               setEventsType(prev => ({
                  ...prev,
                  isManage: false,
                  isDetails: false,
               }))
            }}
         />
         <DeleteModal
            isOpen={openDelModal}
            toggleFunction={setOpenDelModal}
            id={delId}
            apiFunction={DeletePackage}
            title={"Package"}
            requestFunction={() => {
               setDelId(null)
               request()
            }}
         />
      </>
   )
}

export default GlobalPackages
